import styled, { css } from 'styled-components';

export const CheckboxListItem = styled.li`
    ${({ theme }) => css`
        padding: 0.75rem;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            padding: 1.25rem 0.5rem;
            border-top: ${theme.commonStyles.brandPixel} solid
                ${theme.colors.secondary.tints[1].hex};

            &:last-of-type {
                border-bottom: ${theme.commonStyles.brandPixel} solid
                    ${theme.colors.secondary.tints[1].hex};
            }
        }
    `}
`;
